import alerts from './alerts.json'
import connection from './connection.json'

export default {
    alerts,
    connection
}